import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=1cae940b&scoped=true&"
import script from "./customTable.vue?vue&type=script&lang=js&"
export * from "./customTable.vue?vue&type=script&lang=js&"
import style0 from "./customTable.vue?vue&type=style&index=0&id=1cae940b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cae940b",
  null
  
)

export default component.exports